export default __webpack_public_path__ + "static/media/gallery6.6534e067.jpg";